import Header from "../../components/header/Header";
import style from "./category.module.css";
import { configAction } from "../../store/config/slice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { GameStep } from "../../types/config";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import FooterCo from "../../components/footer/FooterCo";
import { categoriesType } from "../../types/categories";
import { categoriesAction } from "../../store/categories/slice";
import { updateUrlParams } from "../../helpers/url";
import useWebEngageCategoryClick from "../../hooks/webengage/useWebEngageCategoryClick";
const CategoryPage = () => {
  const dispatch = useAppDispatch();
  const { trackWebEngageCategoryClick } = useWebEngageCategoryClick();
  // const sendDataToGTM = useGTMDispatch();
  const categories = useAppSelector(
    (state) => state.categories.categories.data
  );
  const handleBack = function () {
    dispatch(configAction.setGameStep(GameStep.HOME));
  };
  const handleSelectCategory = function (category: categoriesType) {
    // sendDataToGTM({
    //   event: "GardoonebaniShans1402-Category",
    //   category: `GardoonebaniShans1402-Category_${category.name}`,
    // });
    dispatch(categoriesAction.setSelectedCategory(category));
    dispatch(configAction.setGameStep(GameStep.GAME));
    updateUrlParams({ category: category.category });
    trackWebEngageCategoryClick(category.name);
  };
  const brandsdata = categories?.filter((item) => item.type === "brand");
  const categoriesdata = categories?.filter(
    (item) => item.type === "category" || item.type === "is_special"
  );

  return (
    <div className={style.category}>
      <Header chance title="انتخاب دسته‌بندی" onBack={handleBack} />
      <div className={`${style.inner} `}>
        <div className={`${style.categoryBox} slide-right`}>
          <div className={style.title}>
            <span>دوست داری چی ببری؟</span>
          </div>
          <div className={style.desc}>
            <span>از دسته‌بندی‌های زیر انتخاب کن.</span>
          </div>
          <div className="flex flex-col justify-center items-center w-full">
            <div className={`${style.items} ${style.brandItems}`}>
              {brandsdata?.map((item: categoriesType, index) => (
                <button
                  className={style.item}
                  key={index}
                  onClick={() => handleSelectCategory(item)}
                >
                  <span className={style.name}>{item.name}</span>
                  <img src={item.icon} alt="" className={style.image} />
                </button>
              ))}
            </div>
            {!!brandsdata?.length && (
              <div className={style.line}>
                <span></span>
                <p>یا</p>
                <span></span>
              </div>
            )}

            <div className={style.items}>
              {categoriesdata?.map((item: categoriesType, index) => (
                <button
                  className={`${style.item} ${
                    item.type === "is_special" ? style.special : ""
                  }`}
                  style={{ width: item.type === "is_special" ? "98%" : "48%" }}
                  key={index}
                  onClick={() => handleSelectCategory(item)}
                >
                  <img src={item.icon} alt="" className={style.image} />
                  <span className={style.name}>{item.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      <FooterCo className="desktop" />
    </div>
  );
};

export default CategoryPage;
